import 'element-plus/dist/index.css'
import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueViewer from 'v-viewer'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores'
import { getRolesService, getDictDetailService, searchHospitalService } from './api'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

const getDicts = getDictDetailService('100')
const getRoles = getRolesService()
const getHospitals = searchHospitalService()

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(VueViewer)

const { setRoles, setDicts, setHospitals } = useAuthStore()

Promise.all([getDicts, getRoles, getHospitals]).then(([dictsRes, rolesRes, hospitalsRes]) => {
  if (dictsRes.code === '1000') {
    setDicts(dictsRes.data)
  }

  if (rolesRes.code === '1000') {
    setRoles(rolesRes.data)
  }

  if (hospitalsRes.code === '1000') {
    setHospitals(hospitalsRes.data.map((v) => ({ label: v.hospitalName, value: v.sn })))
  }

  app.mount('#app')
})
